import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Role } from '@classes/user/user-platform';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(
    private http: HttpClient
  ) { }

  /* ----------------------------------- GET ---------------------------------- */

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${environment.apiUrl}/roles`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

  /* -------------------------------------------------------------------------- */

}
